import { DOCUMENT } from "@angular/common";
import { Component, Inject } from "@angular/core";

import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-rodape',
    templateUrl:'./rodape.component.html',
    styleUrls:['./rodape.component.scss']
})
export class RodapeComponent {
    dominio: string;
    version: string;
    
    constructor(
        @Inject(DOCUMENT) private document: Window
        ) {
            this.dominio = this.document.location.hostname;
            this.version = environment.version;
    }    
}